import { render, staticRenderFns } from "./ResidenceWizard.vue?vue&type=template&id=a89f31c2&scoped=true&"
import script from "./ResidenceWizard.vue?vue&type=script&lang=js&"
export * from "./ResidenceWizard.vue?vue&type=script&lang=js&"
import style0 from "./ResidenceWizard.vue?vue&type=style&index=0&id=a89f31c2&lang=scss&scoped=true&"
import style1 from "./ResidenceWizard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89f31c2",
  null
  
)

export default component.exports